<template>
  <div class="unavailability-date-helper card">
    <div v-if="isCandidate" class="note mb-2 card-header">
      {{ $t("UnavailabilityHelper.info") }}
    </div>

    <div class="legends card-body">
      <div class="row">
        <div class="col-sm-6 col-xl-12 align-items-center">
          <div class="legend d-flex align-items-center">
            <div class="legend-square"></div>
            <div class="ml-2">{{ $t('UnavailabilityHelper.personal_whole_day') }}</div>
          </div>
        </div>

        <div class="col-sm-6 col-xl-12 align-items-center mt-2">
          <div class="legend d-flex align-items-center">
            <div class="legend-circle"></div>
            <div class="ml-2">{{ $t('UnavailabilityHelper.personal') }}</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-sm-6 col-xl-12 align-items-center mt-2">
          <div class="legend d-flex align-items-center">
            <div class="legend-circle legend-circle--green"></div>
            <div class="ml-2">{{ $t('UnavailabilityHelper.validated_replacement') }}</div>
          </div>
        </div>

        <div v-if="hasUnavailabilityDatesProvider" class="col-sm-6 col-xl-12 align-items-center mt-2">
          <div class="legend d-flex align-items-center">
            <div class="legend-circle legend-circle--blue"></div>
            <div class="ml-2">{{ $t('UnavailabilityHelper.ts_planner') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { checkRoleCandidate } from '@/helpers/roles'
export default {
  name: "UnavailabilityHelpers",
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser',
    }),
    isCandidate(){
      return checkRoleCandidate(this.currentUser.role)
    },
    hasUnavailabilityDatesProvider() {
      return this.currentUser.has_dates_provider
    }
  }
}
</script>

<style scoped lang="scss">
  .unavailability-date-helper {
    display: block;
    font-size: 13px;
    margin: 0px auto;
    box-shadow: 0 0px 8px 0px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    margin-bottom: 30px;

    .note {
      padding: 5px 10px 5px 10px;
      background-color: #f7f7f7;
    }

    .legend {
      text-align: left;
      div {
        display: inline-block;
      }
    }

    .legend-square {
      width: 15px;
      height: 15px;
      background: #e61349;
      border-radius: 2px;
      display: inline-block;
    }

    .legend-circle {
      width: 15px;
      height: 15px;
      background: #e61349;
      border-radius: 50%;
      display: inline-block;

      &--blue {
        background: #4e73df;
      }

      &--green {
        background: #04be8c;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/unavailabilityCalendars/UnavailabilityHelpers.vue